import type { NskResponse } from "~/models/Api";
import type { VendorCompanyCreateParams } from "~/models/VendorCompany";
import { postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/admin/vendor_companies",
	proxyLogin: "/admin/vendor_companies/:id/proxy_login"
};

export const create = async (
	vendorCompany: VendorCompanyCreateParams
): Promise<NskResponse> => postRequest(paths.create, { vendorCompany });

export const proxyLogin = async (
	vendorCompanyId: number
): Promise<NskResponse> =>
	postRequest(paths.proxyLogin.replace(":id", String(vendorCompanyId)));
